'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';
import {setupFormValidation} from '../../app/script';

EwSiteApp.controller('processCreatingCtrl', ['$scope', '$http', '$sce', '$compile', '$timeout', '$location', function ($scope, $http, $sce, $compile, $timeout, $location) {

		$scope.navigation = jsNavigation;
		$scope.data = null;
		$scope.contentLoaded = false;
		$scope.content = false;
		$scope.loading = false;
		$scope.submitted = false;
		$scope.errors = [];
		$scope.loadProcessUrl = jsProcessCreating.loadProcessUrl;
		$scope.baseUrl = jsProcessCreating.baseUrl;
		$scope.navigationIsCustom = false;
		$scope.firstWizardWindowData = null;
		$scope.breadcrumbs = [];
		$scope.form_title = '';
		const titleEl = document.querySelector('h1.main_title.desktop');
		if (!titleEl.dataset.originalHtml) {
			titleEl.dataset.originalHtml = titleEl.innerHTML;
		}
		$scope.addBreadcrumb = function (item, link = 'javascript:void(0)') {
			const exists = $scope.breadcrumbs.some(b => b.id === item.id);
			if (!exists) {
				$scope.breadcrumbs.push({ id: item.id, title: item.title, link });
			}
		};

		$scope.removeLastBreadcrumb = function () {
			if ($scope.breadcrumbs.length > 1) {
				$scope.breadcrumbs.pop();
			}
		};

		$scope.loadItem = function (item) {
			$scope.submitted = false;
			titleEl.innerHTML = titleEl.dataset.originalHtml;
			if (item.data_url !== '') {
				$scope.loading = true;
				$http({
					method: 'GET',
					url: item.data_url
				}).then(function (response) {
					$scope.loading = false;

//					$scope.addBreadcrumb(response.data.data);
					if(response.data.breadcrumbs){
						$scope.breadcrumbs = response.data.breadcrumbs;
					}

					if (response.data.content) {
						var compiledElement = $compile(response.data.content)($scope);
						var targetElement = angular.element(document.getElementById('content_ctrl'));
						targetElement.empty();
						targetElement.append(compiledElement);

						$scope.contentLoaded = true;

						// Run any JS variables returned by backend
						if (typeof (response.data.jsvars) !== 'undefined') {
							for (let j of response.data.jsvars) {
								eval(j);
							}
						}
						$scope.nodeId = jsForms.nodeId;
						$scope.storeParams = jsForms.storeParams;
						$scope.allowSaveList = jsForms.allowSaveList;
						// Cia paleidziam funckijas
						$timeout(function () {
							// Forma i DOM patenka po $(document).ready(), todel jquery-validation
							// jai prijungiam cia - kitaip klaidu pranesimai po laukais nerodomi.
							// select2 nekuriam is naujo, ta daro pop-up-select direktyva.
							if (angular.element('#forms_form').length) {
								setupFormValidation('#forms_form', false);
							}
							if (angular.element('.s--themeslist').length) {
								$scope.themesListToggle();
							}
							if (angular.element('.s--duk').length) {
								$scope.dukToggle();
							}
							if (angular.element('.s--contacts').length) {
								$scope.contactsToggle();
							}
							if (angular.element('.s--message').length) {
								$scope.alertsControl();
							}
							if (angular.element('.s--links').length) {
								$scope.initImportantLinksSlider();
							}
							if (angular.element('.s--newnews').length) {
								$scope.initNewsSlider();
							}
							if (angular.element('.s--gamvartskaiciuokle').length) {
								$scope.initGvsCalculator();
							}
						}, 0);

					} else {
						$scope.resetCompiledContent();
					}

					$scope.navigationIsCustom = response.data.navigationIsCustom;
					if (response.data.navigation) {
						$scope.navigation = response.data.navigation;
					}

					if (response.data.data) {
						$scope.contentLoaded = true;
						$scope.data = response.data.data;
						$scope.form_title = $scope.data.title;
						if($scope.data.form_title){
							$scope.form_title = $scope.data.form_title;
						}
					}


				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};

		// Navigation & steps
		$scope.currentSteps = [];
		$scope.currentStepsString = '';
		$scope.urlParams = {steps: [], slugs: []};

		var queryString = window.location.search;

		$scope.goToNextStep = function (stepId) {
			if ($scope.currentSteps.indexOf(stepId) === -1) {
				$scope.currentSteps.push(stepId);
			}
			$scope.currentStep = stepId;

			let indx = $scope.urlParams.steps.indexOf(stepId);
			if (indx === -1) {
				$scope.urlParams.steps.push(stepId);
//				setQueryData();//si darba perima $scope.$watch('breadcrumbs'
			}
		};

		function parseSearch() {
			if (queryString && queryString.length > 1 && queryString[0] === '?') {
				const stepsString = queryString.substring(1);
				const rawSteps = stepsString.split(',');
				$scope.urlParams.steps = rawSteps.map(step => step.trim()).filter(step => step.length > 0);
			}
			return $scope.urlParams;
		}

		const parsedParams = parseSearch();
		const currentStep = parsedParams.steps[parsedParams.steps.length - 1];

		if (currentStep) {
			const stepNumber = parseInt(currentStep.replace('s', ''));
			if (!isNaN(stepNumber)) {
				let item = {
					id: stepNumber,
					data_url: $scope.loadProcessUrl + stepNumber + '/data'
				};
				$scope.loadItem(item);
				$scope.goToNextStep('s' + item.id);
			}
		}

		window.addEventListener('popstate', function(event) {
			$scope.$applyAsync(() => {
				$scope.urlParams = {steps: []};
				queryString = window.location.search;
				const parsedParams = parseSearch();
				const currentStep = parsedParams.steps[parsedParams.steps.length - 1];
				if (currentStep) {
					const stepNumber = parseInt(currentStep.replace('s', ''));
					if (!isNaN(stepNumber)) {
						let item = {
							id: stepNumber,
							data_url: $scope.loadProcessUrl + stepNumber + '/data'
						};
						$scope.loadItem(item);
						$scope.goToNextStep('s' + item.id);
					}
				}
				else{
					$scope.reset();
				}
			});
		});


		function setQueryData() {
			queryString = '?' + formatHistoryQuery();
			history.pushState("", document.title, window.location.pathname + queryString);
		}

		function formatHistoryQuery() {
			return $scope.urlParams.steps.join(',');
		}

		var urlInitialized = false;

		$scope.$watch('breadcrumbs', function (nv, ov) {
			if (!nv) { return; }
			$scope.updateUrlFromBreadcrumbs();
		}, true);

		$scope.updateUrlFromBreadcrumbs = function () {
//			if (!$scope.breadcrumbs || !$scope.breadcrumbs.length) {
//			  return window.location.pathname;
//			}

//			**
			var currentPath = window.location.pathname.replace(/\/+$/, '');
			// pirmas kvietimas ir breadcrumbs tušti – NIEKO NEDAROM su URL
			if (!urlInitialized) {
			  urlInitialized = true;

			  if (!$scope.breadcrumbs || !$scope.breadcrumbs.length) {
				return currentPath; // paliekam kaip yra
			  }
			}

			// jei breadcrumbs tušti vėliau (pvz. per reset) – tada jau trumpinam
			if (!$scope.breadcrumbs || !$scope.breadcrumbs.length) {
//				var match = currentPath.match(/^(\/esoew4\/proceso-kurimas-test\/\d+)/);
//				var basePath = match ? match[1] + '/' : '/esoew4/proceso-kurimas-test/';
//				if (basePath !== currentPath + '/') {
//					history.pushState('', document.title, basePath);
//				}
//				return basePath;
				if (currentPath + '/' !== $scope.baseUrl) {
					history.pushState('', document.title, $scope.baseUrl);
				}
				return $scope.baseUrl;
			}

//			**


			// surenkam slugs eilės tvarka
			var slugs = $scope.breadcrumbs
			  .map(function (b) { return b && b.slug; })
			  .filter(Boolean);

			if (!slugs.length) {
			  return window.location.pathname;
			}

			var currentPath = window.location.pathname.replace(/\/+$/, '');

			// susirandam, nuo kur prasideda breadcrumb dalis URL'e
			// pvz.: /esoew4/proceso-kurimas-test/3498/susisiekite-internetu/privatiems
			//                        ^ čia prasideda /susisiekite-internetu
			var basePath = currentPath;
			var firstSlug = '/' + slugs[0];
			var idx = currentPath.indexOf(firstSlug);

			if (idx !== -1) {
			  basePath = currentPath.slice(0, idx); // viskas iki breadcrumb dalies
			}

			// nauja uodega iš breadcrumbs slugs
			var newPath = (basePath + '/' + slugs.join('/')).replace(/\/+$/, '') || '/';

			// kad nespaminti history, pushinam tik jei realiai keičiasi
			if (newPath !== currentPath) {
			  history.pushState('', document.title, newPath);
			}

			return newPath;
		};

		$scope.getIconPath = function (item) {
			return item.icon || '';
		};

		$scope.explicitlyTrustedHtml = function (text) {
			return $sce.trustAsHtml(text);
		};

		//Pradinio vedlio lango rodymas iš pirmo elemento turinio
		if (typeof (jsProcessCreating.firstWizardWindow) !== 'undefined') {
			$scope.navigationIsCustom = true;
			$scope.firstWizardWindowData = jsProcessCreating.firstWizardWindow;
			if($scope.urlParams.steps.length<1){
				$scope.loadItem(jsProcessCreating.firstWizardWindow);
			}
		}

		$scope.reset = function () {
			$scope.submitted = false;
			titleEl.innerHTML = titleEl.dataset.originalHtml;
			$scope.breadcrumbs = [];
			$scope.navigation = jsNavigation;
			$scope.data = null;
			$scope.contentLoaded = false;
			$scope.content = false;
			$scope.resetCompiledContent();
			$scope.urlParams = {steps: []};
			const baseUrl = window.location.origin + window.location.pathname;
			window.history.pushState({}, '', baseUrl);
			$scope.currentSteps = [];
			$scope.currentStep = '';
			if($scope.firstWizardWindowData){
				if($scope.firstWizardWindowData.preview_mode){
					$scope.firstWizardWindowData.data_url = $scope.loadProcessUrl + $scope.firstWizardWindowData.id + '/data'
				}
				$scope.loadItem($scope.firstWizardWindowData);
			}
			$scope.$applyAsync();
		};

		$scope.resetCompiledContent = function () {
			var compiledElement = $compile("")($scope);
			var targetElement = angular.element(document.getElementById('content_ctrl'));
			targetElement.empty();
			targetElement.append(compiledElement);
		};

		$scope.back = function () {
			if ($scope.data.back_url) {
				$scope.removeLastBreadcrumb();
				$scope.data.data_url = $scope.data.back_url;
				$scope.loadItem($scope.data);
				$scope.goToPrevStep();
			} else {
				$scope.reset();
			}
		};

		$scope.goToPrevStep = function () {
			if ($scope.currentSteps.length > 1) {
				$scope.currentSteps.pop();
				$scope.currentStep = $scope.currentSteps[$scope.currentSteps.length - 1];
				$scope.updateUrl();
			}
		};

		$scope.updateUrl = function () {
			$scope.currentStepsString = $scope.currentSteps.join(',');
			const newPath = $location.path();
			const newUrl = `${newPath}?${$scope.currentStepsString}`;
			window.history.pushState({steps: $scope.currentSteps}, '', newUrl);
		};

		//Funkcijos is script.js, kad veiktu angulare
		//Funkcijos is script.js, kad veiktu angulare
		//Funkcijos is script.js, kad veiktu angulare
		$scope.themesListToggle = function () {
			var categoryItems = $('.themeslist__item[id^="c"]:not([id*="t"])');
			var topicItems = $('.themeslist__item[id*="t"]');
			var questionWrappers = document.querySelectorAll('.themeslist__item.toggleable .question-wrapper');

			questionWrappers.forEach(function (questionWrapper) {
				questionWrapper.addEventListener('click', function (event) {
					var parentItem = this.parentElement;
					var isCategory = parentItem.getAttribute('id').indexOf('-t') === -1;
					var isActive = parentItem.classList.contains('active');

					if (isCategory) {
						categoryItems.removeClass('active');
						topicItems.removeClass('active');
						if (!isActive) {
							parentItem.classList.add('active');
							scrollIntoView(parentItem);
							var itemId = parentItem.getAttribute('id');
							if (itemId)
								history.replaceState(null, null, '#' + itemId);
						} else {
							history.replaceState(null, null, ' ');
						}
					} else {
						var parentCategoryId = parentItem.getAttribute('id').split('-t')[0];
						var parentCategory = document.getElementById(parentCategoryId);
						if (parentCategory) {
							categoryItems.removeClass('active');
							parentCategory.classList.add('active');
						}
						topicItems.removeClass('active');
						if (!isActive) {
							parentItem.classList.add('active');
							scrollIntoView(parentItem);
							var itemId = parentItem.getAttribute('id');
							if (itemId)
								history.replaceState(null, null, '#' + itemId);
						} else {
							history.replaceState(null, null, '#' + parentCategoryId);
						}
					}

					event.stopPropagation();
				});
			});

			var hash = window.location.hash.substring(1);
			if (hash) {
				var parts = hash.split('-');
				var categoryId = parts[0];
				var topicId = parts.length > 1 ? parts.join('-') : null;

				var activeCategory = document.getElementById(categoryId);
				if (activeCategory) {
					categoryItems.removeClass('active');
					activeCategory.classList.add('active');
					if (topicId) {
						var activeTopic = document.getElementById(topicId);
						if (activeTopic) {
							topicItems.removeClass('active');
							activeTopic.classList.add('active');
							scrollIntoView(activeTopic);
						}
					} else {
						scrollIntoView(activeCategory);
					}
				}
			}

			function scrollIntoView(element) {
				var elementPosition = element.getBoundingClientRect().top + window.scrollY;
				var offset = window.innerWidth >= 1024 ? 16 : 100;
				window.scrollTo({
					top: elementPosition - offset,
					behavior: 'smooth'
				});
			}
		};
		$scope.dukToggle = function () {
			var items = angular.element('.duk__list .duk__item');
			var isFaqList = angular.element('.duk__list').hasClass('duk__list--faq');
			var isWideScreen = window.innerWidth >= 1024;

			var firstWrapper, secondWrapper, thirdWrapper;

			if (isFaqList && isWideScreen) {
				var third = Math.ceil(items.length / 3);
				var firstThird = items.slice(0, third);
				var secondThird = items.slice(third, third * 2);
				var lastThird = items.slice(third * 2);

				firstWrapper = angular.element('<div class="wrapper"></div>');
				secondWrapper = angular.element('<div class="wrapper"></div>');
				thirdWrapper = angular.element('<div class="wrapper"></div>');

				firstThird.wrapAll(firstWrapper);
				secondThird.wrapAll(secondWrapper);
				lastThird.wrapAll(thirdWrapper);
			} else {
				var half = Math.ceil(items.length / 2);
				var firstHalf = items.slice(0, half);
				var secondHalf = items.slice(half);

				firstWrapper = angular.element('<div class="wrapper"></div>');
				secondWrapper = angular.element('<div class="wrapper"></div>');

				firstHalf.wrapAll(firstWrapper);
				secondHalf.wrapAll(secondWrapper);
			}

			// Click toggle logic
			var questionWrappers = document.querySelectorAll('.duk__item.toggleable .question-wrapper');

			questionWrappers.forEach(function (questionWrapper) {
				questionWrapper.addEventListener('click', function () {
					var parentItem = this.parentElement;
					var isActive = parentItem.classList.contains('active');

					items.removeClass('active');

					if (!isActive) {
						parentItem.classList.add('active');
						scrollIntoView(parentItem);
						var itemId = parentItem.getAttribute('id');
						if (itemId) {
							history.replaceState(null, null, '#' + itemId);
						}
					} else {
						history.replaceState(null, null, ' ');
					}
				});
			});

			// Auto-activate by URL hash
			var hash = window.location.hash.substring(1);
			if (hash) {
				var activeItem = document.getElementById(hash);
				if (activeItem) {
					items.removeClass('active');
					activeItem.classList.add('active');
					scrollIntoView(activeItem);
				}
			}

			function scrollIntoView(element) {
				var elementPosition = element.getBoundingClientRect().top + window.scrollY;
				var offset = window.innerWidth >= 1024 ? 50 : 100;
				var offsetPosition = elementPosition - offset;

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				});
			}
		};
		$scope.contactsToggle = function () {
			function resetSubLevel(parentBlock) {
				const subToggles = parentBlock.querySelectorAll('.contacts__toggle--sub');
				subToggles.forEach(toggle => toggle.classList.remove('active'));
				if (subToggles.length > 0) {
					subToggles[0].classList.add('active');
				}

				const subBlocks = parentBlock.querySelectorAll('.contacts__block');
				subBlocks.forEach(block => block.classList.remove('active'));
				if (subBlocks.length > 0) {
					subBlocks[0].classList.add('active');
				}
			}

			// Handle top-level toggle clicks
			const topToggles = document.querySelectorAll('.contacts__toggle:not(.contacts__toggle--sub)');
			topToggles.forEach(toggle => {
				toggle.addEventListener('click', function () {
					const id = this.id;
					const parentWrapper = this.closest('.contacts');

					if (!parentWrapper)
						return;

					const siblingToggles = parentWrapper.querySelectorAll('.contacts__toggle:not(.contacts__toggle--sub)');
					const siblingBlocks = parentWrapper.querySelectorAll('.contacts__block');

					siblingToggles.forEach(t => t.classList.remove('active'));
					siblingBlocks.forEach(block => block.classList.remove('active'));

					this.classList.add('active');

					const activeBlock = parentWrapper.querySelector(`.contacts__block[data-id="${id}"]`);
					if (activeBlock) {
						activeBlock.classList.add('active');
						resetSubLevel(activeBlock);
					}
				});
			});

			// Handle sub-toggle clicks using event delegation
			document.addEventListener('click', function (event) {
				if (event.target.classList.contains('contacts__toggle--sub')) {
					const subToggle = event.target;
					const id = subToggle.id;

					const parentBlock = subToggle.closest('.contacts__block');
					if (!parentBlock)
						return;

					const siblingToggles = parentBlock.querySelectorAll('.contacts__toggle--sub');
					const siblingBlocks = parentBlock.querySelectorAll('.contacts__block');

					siblingToggles.forEach(t => t.classList.remove('active'));
					siblingBlocks.forEach(block => block.classList.remove('active'));

					subToggle.classList.add('active');

					const activeSubBlock = parentBlock.querySelector(`.contacts__block[data-id="${id}"]`);
					if (activeSubBlock) {
						activeSubBlock.classList.add('active');
					}
				}
			});
		};
		$scope.alertsControl = function () {
			if (angular.element(".s--message").length) {
				let messageClose = angular.element(".s--message .message .close");
				let imgneditor = angular.element(".s--imgneditor");

				messageClose.on("click", function () {
					angular.element(this).closest('.s--message').remove();
					imgneditor.removeClass("has-message-above");
				});
			}
		};
		$scope.initImportantLinksSlider = function () {
			if (angular.element(".important-links-slider").length > 0) {
				angular.element(".important-links-slider").slick({
					prevArrow: '<button class="mygtukas mygtukas--arrow mygtukas--arrow-left" aria-label="previous"></button>',
					nextArrow: '<button class="mygtukas mygtukas--arrow mygtukas--arrow-right" aria-label="next"></button>',
					dots: false,
					arrows: true,
					infinite: false,
					slidesToShow: 4,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 3,
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 3,
								dots: true
							}
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 2,
								dots: true
							}
						},
						{
							breakpoint: 475,
							settings: {
								slidesToShow: 2,
								dots: true
							}
						}
					],
				});
			}
		};
		$scope.initNewsSlider = function () {
			if (angular.element(".news__slider").length > 0) {
				var $slider = angular.element('.news__slider');

				$slider.on('init', function (event, slick) {
					var slideCount = slick.slideCount;
					var slidesToShow = slick.options.slidesToShow;

					if (slideCount > slidesToShow) {
						$slider.addClass('activated');
					} else {
						$slider.removeClass('activated');
						angular.element('.slider-nav').remove(); // Remove nav if not activated
					}
				});

				$slider.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
							}
						},
						{
							breakpoint: 475,
							settings: {
								slidesToShow: 1,
							}
						}
					]
				});

				// Wait for slick to init before binding nav click handlers
				$timeout(function () {
					if ($slider.hasClass('activated')) {
						angular.element('.news .slider-nav .prev').on('click', function () {
							$slider.slick('slickPrev');
						});
						angular.element('.news .slider-nav .next').on('click', function () {
							$slider.slick('slickNext');
						});
					}
				}, 100); // Slight delay to ensure slider initialized
			}
		};
		$scope.initGvsCalculator = function () {
			if (typeof gvsParams !== 'undefined' && angular.element("#gvs_calculator").length) {
				$timeout(function () {
					if (typeof window.gvsCalculator !== 'undefined') {
						window.gvsCalculator.init();
					} else {
						console.warn("gvsCalculator not found.");
					}
				}, 0);
			} else {
				console.warn("gvsParams undefined or calculator container not found.");
			}
		};



	}]);


EwSiteApp.controller('processcreatingFormsCtrl', ['$controller', '$scope', '$filter', '$log', '$uibModal', 'ajaxSearch', '$http', '$compile', 'localStorageService', function ($controller, $scope, $filter, $log, $uibModal, ajaxSearch, $http, $compile, localStorageService) {
		$controller('formSubmitCtrl', {$scope: $scope, $filter: $filter, $log: $log, $uibModal: $uibModal, ajaxSearch: ajaxSearch, localStorageService: localStorageService});
		function getDefaultData() {
			return {
				recaptchaResponse: null,
			};
		}
		$scope.formData = getDefaultData();

		$scope.lsKey = function(){ return `processcreating_form_${$scope.nodeId}`; }

		$scope.formSubmit = function (e) {
			e.preventDefault();
			$scope.$parent.loading = true;
			$scope.$parent.submitted = false;

			$scope.nodeId = jsForms.nodeId;
			$scope.storeParams = jsForms.storeParams;
			$scope.allowSaveList = jsForms.allowSaveList;
			$scope.saveToLocalStorage();
//		let is_grecaptcha = document.getElementById('recaptcha-token');
			if (/*is_grecaptcha && */typeof (grecaptcha) !== 'undefined') {
				grecaptcha.ready(function () {
					grecaptcha.execute(jsProcessCreating.recaptcha.siteKey, {action: 'submit'}).then(function (token) {
						$scope.formData.recaptchaResponse = token;
						$scope.submitFormPost();
					});
				});
			}
		};

		$scope.submitFormPost = function () {
			$scope.messages = [];
			// išvalome ankstesnio bandymo klaidas, kad jos neliktų kabėti po sėkmingo pateikimo
			$scope.$parent.errors = [];
			$scope.responseFalse = false;
			$http({
				method: 'POST',
				url: processcreatingSubmitUrl,
				data: getPostData(),
//			transformRequest: angular.identity,
//            headers: {
//                'Content-Type': "multipart/form-data"
//            },
//			headers: { 'Content-Type': undefined },
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				$scope.$parent.loading = false;
				if (response.data.success) {
					$scope.$parent.submitted = true;
					document.querySelector('h1.main_title.desktop').innerHTML = '';
//				$scope.submitted = false;
					if (response.data.content) {
						// Sukompiliuojame norimą HTML
						var compiledElement = $compile(response.data.content)($scope);
//
//					// Gauname DOM elementą, į kurį norime įterpti
						var targetElement = angular.element(document.getElementById('content_ctrl'));
//
//					// Išvalome seną turinį (neprivaloma, bet dažnai naudinga)
						targetElement.empty();
//
//					// Įterpiame sukompiliuotą elementą
						targetElement.append(compiledElement);
					}
//				form.$setPristine();
//				form.$setUntouched();
//				form.$submitted = false;
//				fixView();
				} else {
					if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
						$scope.$parent.errors = response.data.errors;
					}

//				$scope.submitted = false;
//				$scope.responseFalse = true;
//				if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
//					$scope.messages = response.data.errors;
//				}
				}
			}).then(function () {
				$scope.loading = false;
			});
		};

		function getPostData() {
			var formDataArray = $scope.form.serializeArray();

			var structuredFormData = parseFormFields(formDataArray);

			if (typeof jsProcessCreating.recaptcha !== 'undefined') {
				structuredFormData[jsProcessCreating.recaptcha.field] = $scope.formData.recaptchaResponse;
			}

			return structuredFormData;
		}
		/*
		 function parseFormFields(formDataArray) {
		 var result = {};
		 angular.forEach(formDataArray, function(field) {
		 var name = field.name;
		 var value = field.value;

		 // Reguliarioji išraiška ieško [...] modelio
		 var match = name.match(/^([^\[]+)\[(\d+)\]$/);

		 if (match) {
		 // Jei atitinka "field[index]" modelį
		 var baseName = match[1]; // pvz., "choise_id"
		 var index = match[2];    // pvz., "14"

		 if (!result[baseName]) {
		 result[baseName] = {}; // Sukuriame bazinį objektą, jei dar nėra
		 }
		 result[baseName][index] = value;
		 } else {
		 // Jei tai paprastas lauko pavadinimas (pvz., "username", "email")
		 result[name] = value;
		 }
		 });
		 return result;
		 }*/

		function parseFormFields(formDataArray) {
			var result = {};
			angular.forEach(formDataArray, function (field) {

				var name = field.name;
				var value = field.value;

				// 1. Pirmiausia bandome atpažinti formatą "field[index][]"
				//    Pvz.: "choise_id[16][]"
				var matchArray = name.match(/^([^\[]+)\[(\d+)\]\[\]$/);

				if (matchArray) {
					var baseName = matchArray[1]; // pvz., "choise_id"
					var index = matchArray[2];    // pvz., "16"

					if (!result[baseName]) {
						result[baseName] = {}; // Sukuriame bazinį objektą, jei dar nėra
					}
					if (!Array.isArray(result[baseName][index])) {
						// Jei šis indeksas dar nėra masyvas, inicializuojame jį kaip tuščią masyvą
						result[baseName][index] = [];
					}
					// Pridedame reikšmę į masyvą
					result[baseName][index].push(value);

				} else {
					// 2. Jei neatitinka "field[index][]", tada bandome atpažinti "field[index]" formatą
					//    Pvz.: "choise_id[14]" arba "choise_id[17]"
					var matchIndex = name.match(/^([^\[]+)\[(\d+)\]$/);

					if (matchIndex) {
						var baseName = matchIndex[1]; // pvz., "choise_id"
						var index = matchIndex[2];    // pvz., "14" arba "17"

						if (!result[baseName]) {
							result[baseName] = {}; // Sukuriame bazinį objektą, jei dar nėra
						}
						// Tiesiogiai priskiriame reikšmę, nes tai nėra masyvas
						result[baseName][index] = value;

					} else {
						// 4. Ši reguliarioji išraiška suskaido pavadinimą į atskirus segmentus.
						// Pvz.: "files[22][6889]" taps ["files", "[22]", "[6889]"]
						var matchIndex = name.match(/[^[\]]+|\[[d\]]*\]/g);
						if (matchIndex && matchIndex[0] == "files") {
							var baseName = matchIndex[0];
							var index = matchIndex[1];
							var index2 = matchIndex[2];

							if (!result[baseName]) {
								result[baseName] = {}; // Sukuriame bazinį objektą, jei dar nėra
							}
							if (!result[baseName][index]) {
								// Jei šis indeksas dar nesukurtas, inicializuojame jį kaip tuščią objektą.
								// Array.isArray() patikra nebenaudojama, nes objektas {} nėra masyvas - dėl to ankstesni failai būdavo perrašomi, postinant tik paskutinį prisegtą failą.
								result[baseName][index] = {};
							}
//						if (!Array.isArray(result[baseName][index][index2])) {
//							result[baseName][index][index2] = [];
//						}
							// Pridedame reikšmę į masyvą
//						result[baseName][index] = {index2: value};
							result[baseName][index][index2] = value;

						} else {
							// 3. Jei neatitinka nei vieno iš aukščiau, tai yra paprastas lauko pavadinimas
							//    Pvz.: "username", "email"
							result[name] = value;

						}
					}
				}
			});
			return result;
		}



	}]);





